export default __webpack_public_path__ + "static/media/fc-bg.5de30b69.jpg";